import React from "react";

function ScriptCont(props){
    return(
        <section className={`script__cont  ${props.color}`}>
            <div className="container">
                <div className="script__inner">
                        <div className="script">
                            <figure className="img">
                                <a href="/"><img src="/img/script01.png" alt="port01" /></a>
                            </figure>
                            <div className="desc">
                                <h3>animationRequestFrame</h3>
                                <div className="text">
                                    <p className="txt">
                                        레이아웃은 사이트를 만드는데 가장 기본적이 요소입니다. 레이아웃만 제대로 만들 수 있다면 사이트의 제작에 50%는 끝나다고 보셔도 됩니다. 그만큼 레이아웃 제작은 상당히 중요합니다. 사이트의 제작에 50%는 끝나다고 보셔도 됩니다. 그만큼 레이아웃 제작은 상당히 중요합니다.
                                    </p>
                                    <p className="txt">
                                        레이아웃은 사이트를 만드는데 가장 기본적이 요소입니다. 레이아웃만 제대로 만들 수 있다면 사이트의 제작에 50%는 끝나다고 보셔도 됩니다. 그만큼 레이아웃 제작은 상당히 중요합니다. 사이트의 제작에 50%는 끝나다고 보셔도 됩니다. 그만큼 레이아웃 제작은 상당히 중요합니다.
                                    </p >
                                        <ul className="txt btn">
                                            <li><a href="#"> 01</a></li>
                                            <li><a href="#"> 02</a></li>
                                            <li><a href="#"> 03</a></li>
                                            <li><a href="#"> 04</a></li>
                                            <li><a href="#"> 05</a></li>
                                            <li><a href="#"> 06</a></li>
                                            <li><a href="#"> 07</a></li>
                                            <li><a href="#"> 08</a></li>
                                            <li><a href="#"> 09</a></li>
                                            <li><a href="#"> 10</a></li>
                                        </ul>
                                </div>
                            </div>
                        </div>
                        <div className="script">
                            <figure className="img">
                                <a href="/"><img src="/img/script01.png" alt="port01" /></a>
                            </figure>
                            <div className="desc">
                            <ul className="txt btn">
                                            <li><a href="#"> 01</a></li>
                                            <li><a href="#"> 02</a></li>
                                            <li><a href="#"> 03</a></li>
                                            <li><a href="#"> 04</a></li>
                                            <li><a href="#"> 05</a></li>
                                            <li><a href="#"> 06</a></li>
                                            <li><a href="#"> 07</a></li>
                                            <li><a href="#"> 08</a></li>
                                            <li><a href="#"> 09</a></li>
                                            <li><a href="#"> 10</a></li>
                                        </ul>
                                <h3>animationRequestFrame</h3>
                                <div className="text">
                                    <p className="txt">
                                        레이아웃은 사이트를 만드는데 가장 기본적이 요소입니다. 레이아웃만 제대로 만들 수 있다면 사이트의 제작에 50%는 끝나다고 보셔도 됩니다. 그만큼 레이아웃 제작은 상당히 중요합니다. 사이트의 제작에 50%는 끝나다고 보셔도 됩니다. 그만큼 레이아웃 제작은 상당히 중요합니다.
                                    </p>
                                    <p className="txt">
                                        레이아웃은 사이트를 만드는데 가장 기본적이 요소입니다. 레이아웃만 제대로 만들 수 있다면 사이트의 제작에 50%는 끝나다고 보셔도 됩니다. 그만큼 레이아웃 제작은 상당히 중요합니다. 사이트의 제작에 50%는 끝나다고 보셔도 됩니다. 그만큼 레이아웃 제작은 상당히 중요합니다.
                                    </p >
                                        {/* <ul className="txt btn">
                                            <li><a href="#"> 01</a></li>
                                            <li><a href="#"> 02</a></li>
                                            <li><a href="#"> 03</a></li>
                                            <li><a href="#"> 04</a></li>
                                            <li><a href="#"> 05</a></li>
                                            <li><a href="#"> 06</a></li>
                                            <li><a href="#"> 07</a></li>
                                            <li><a href="#"> 08</a></li>
                                            <li><a href="#"> 09</a></li>
                                            <li><a href="#"> 10</a></li>
                                        </ul> */}
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </section>
    )
}

export default ScriptCont;